import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Grid from '@material-ui/core/Grid';


import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';


import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import FormHelperText from '@material-ui/core/FormHelperText';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import HelpIcon from '@material-ui/icons/Help';

import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import Autocomplete from '@material-ui/lab/Autocomplete';


import { useDispatch, useSelector } from 'react-redux';

import { third, errorPage } from '../actions/formActions';

function ElevationScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};


function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/[1-9]/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]}

            showMask
        />
    );
}

TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
};

function TextMaskCustom2(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/[1-9]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}

            showMask
        />
    );
}

TextMaskCustom2.propTypes = {
    inputRef: PropTypes.func.isRequired,
};




const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});



const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
        padding: theme.spacing(0, 3),
    },
    paper: {
        maxWidth: 600,
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(2),
    }, spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    box: {
        display: "flex",
        width: '100%',
        margin: 8,
        marginLeft: 0,
    }, buttonCustom: {
        fontSize: '0.75rem'
    },
    option: {
        fontSize: '0.8rem',
        '& > span': {
            marginRight: 10,
            fontSize: '0.8rem',
        },
    },
    auto: {
        fontSize: '0.1',
    }
}));

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


function FormScreen3() {

    const data = useSelector((state) => state.form.data);

    const dispatch = useDispatch();
    const error = useSelector((state) => state.form.error);

    const { direccion, zona, departamento, municipio, finca, folio, libro, archivo } = data;

    React.useEffect(() => {
        setMunicipios(countries[0].states);
    }, []);

    const onChangeFormulario = e => {
        if (error[e.target.name]) {

            if ((e.target.name === 'direccion' || e.target.name === 'zona') && !isNaN(parseInt(e.target.value))) {
                dispatch(errorPage({
                    ...error,
                    [e.target.name]: false,
                }));
            } else if (!(e.target.name === 'direccion' || e.target.name === 'zona')) {
                dispatch(errorPage({
                    ...error,
                    [e.target.name]: false,
                }));
            }

        }

        const beforeData = data;

        dispatch(third({
            ...data,
            [e.target.name]: e.target.value
        }, beforeData));
    }

    const onChangeFormularioCombo = (event, value, type) => {
        if (error[type]) {
            dispatch(errorPage({
                ...error,
                [type]: false,
            }));
        }
        const beforeData = data;

        if (type === 'departamento') {
            countries.map((dept) => {
                if (dept.name === value.name) {
                    if (departamento === value.name)
                        return 0;
                    setMunicipios(dept.states);
                    dispatch(third({
                        ...data,
                        [type]: value.name === 'Seleccione uno...' ? '' : value.name,
                        'municipio': ''
                    }, beforeData));
                    return 0;
                }
                return 0;
            })
        } else {
            dispatch(third({
                ...data,
                [type]: value.name
            }, beforeData));
        }
    }

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const classes = useStyles();

    const countries = [
        { name: 'Seleccione uno...', value: 'Seleccione uno...', states: [{ name: '', value: '' },], },
        { name: 'Alta Verapaz', value: 'Alta Verapaz', states: [{ name: 'Chahal', value: 'Chahal' }, { name: 'Chisec', value: 'Chisec' }, { name: 'Cobán', value: 'Cobán' }, { name: 'Fray Bartolomé de las Casas', value: 'Fray Bartolomé de las Casas' }, { name: 'San Agustín Lanquín', value: 'San Agustín Lanquín' }, { name: 'Panzós', value: 'Panzós' }, { name: 'Raxruha', value: 'Raxruha' }, { name: 'San Cristóbal Verapaz', value: 'San Cristóbal Verapaz' }, { name: 'San Juan Chamelco', value: 'San Juan Chamelco' }, { name: 'San Pedro Carchá', value: 'San Pedro Carchá' }, { name: 'Santa Cruz Verapaz', value: 'Santa Cruz Verapaz' }, { name: 'Santa María Cahabón', value: 'Santa María Cahabón' }, { name: 'Senahú', value: 'Senahú' }, { name: 'Tactic', value: 'Tactic' }, { name: 'Tamahú', value: 'Tamahú' }, { name: 'Tucurú', value: 'Tucurú' }, { name: 'Santa Catalina la Tinta', value: 'Santa Catalina la Tinta' }], },
        { name: 'Baja Verapaz', value: 'Baja Verapaz', states: [{ name: 'Cubulco', value: 'Cubulco' }, { name: 'Granados', value: 'Granados' }, { name: 'Purulhá', value: 'Purulhá' }, { name: 'Rabinal', value: 'Rabinal' }, { name: 'Salamá', value: 'Salamá' }, { name: 'San Jerónimo', value: 'San Jerónimo' }, { name: 'San Miguel Chicaj', value: 'San Miguel Chicaj' }, { name: 'Santa Cruz El Chol', value: 'Santa Cruz El Chol' }], },
        { name: 'Chimaltenango', value: 'Chimaltenango', states: [{ name: 'Acatenango', value: 'Acatenango' }, { name: 'Chimaltenango', value: 'Chimaltenango' }, { name: 'El Tejar', value: 'El Tejar' }, { name: 'Parramos', value: 'Parramos' }, { name: 'Patzicía', value: 'Patzicía' }, { name: 'Patzún', value: 'Patzún' }, { name: 'Pochuta', value: 'Pochuta' }, { name: 'San Andrés Itzapa', value: 'San Andrés Itzapa' }, { name: 'San José Poaquil', value: 'San José Poaquil' }, { name: 'San Juan Comalapa', value: 'San Juan Comalapa' }, { name: 'San Martín Jilotepeque', value: 'San Martín Jilotepeque' }, { name: 'Santa Apolonia', value: 'Santa Apolonia' }, { name: 'Santa Cruz Balanyá', value: 'Santa Cruz Balanyá' }, { name: 'Tecpán Guatemala', value: 'Tecpán Guatemala' }, { name: 'Yepocapa', value: 'Yepocapa' }, { name: 'Zaragoza', value: 'Zaragoza' },], },
        { name: 'Chiquimula', value: 'Chiquimula', states: [{ name: 'Camotán', value: 'Camotán' }, { name: 'Chiquimula', value: 'Chiquimula' }, { name: 'Concepción Las Minas', value: 'Concepción Las Minas' }, { name: 'Esquipulas', value: 'Esquipulas' }, { name: 'Ipala', value: 'Ipala' }, { name: 'Jocotán', value: 'Jocotán' }, { name: 'Olopa', value: 'Olopa' }, { name: 'Quezaltepeque', value: 'Quezaltepeque' }, { name: 'San Jacinto', value: 'San Jacinto' }, { name: 'San José La Arada', value: 'San José La Arada' }, { name: 'San Juan Ermita ', value: 'San Juan Ermita ' },], },
        { name: 'Petén', value: 'Petén', states: [{ name: 'Dolores', value: 'Dolores' }, { name: 'El Chal', value: 'El Chal' }, { name: 'Flores', value: 'Flores' }, { name: 'La Libertad', value: 'La Libertad' }, { name: 'Las Cruces', value: 'Las Cruces' }, { name: 'Melchor de Mencos', value: 'Melchor de Mencos' }, { name: 'Poptún', value: 'Poptún' }, { name: 'San Andrés', value: 'San Andrés' }, { name: 'San Benito', value: 'San Benito' }, { name: 'San Francisco', value: 'San Francisco' }, { name: 'San José ', value: 'San José ' }, { name: 'San Luis ', value: 'San Luis ' }, { name: 'Santa Ana', value: 'Santa Ana' }, { name: 'Sayaxché', value: 'Sayaxché' },], },
        { name: 'El Progreso', value: 'El Progreso', states: [{ name: 'El Jícaro', value: 'El Jícaro' }, { name: 'Guastatoya', value: 'Guastatoya' }, { name: 'Morazán', value: 'Morazán' }, { name: 'San Agustín Acasaguastlán', value: 'San Agustín Acasaguastlán' }, { name: 'San Antonio La Paz ', value: 'San Antonio La Paz ' }, { name: 'San Cristóbal Acasaguastlán', value: 'San Cristóbal Acasaguastlán' }, { name: 'Sanarate', value: 'Sanarate' }, { name: 'Sansare', value: 'Sansare' },], },
        { name: 'El Quiché', value: 'El Quiché', states: [{ name: 'Canillá', value: 'Canillá' }, { name: 'Chajul', value: 'Chajul' }, { name: 'Chicaman', value: 'Chicaman' }, { name: 'Chiché', value: 'Chiché' }, { name: 'Chichicastenango', value: 'Chichicastenango' }, { name: 'Chinique', value: 'Chinique' }, { name: 'Cunén', value: 'Cunén' }, { name: 'Joyabaj', value: 'Joyabaj' }, { name: 'Nebaj', value: 'Nebaj' }, { name: 'Sacapulas', value: 'Sacapulas' }, { name: 'Patzité', value: 'Patzité' }, { name: 'Pachalum', value: 'Pachalum' }, { name: 'Ixcán', value: 'Ixcán' }, { name: 'San Andrés Sajcabajá', value: 'San Andrés Sajcabajá' }, { name: 'San Antonio Ilotenango ', value: 'San Antonio Ilotenango ' }, { name: 'San Bartolomé Jocotenango', value: 'San Bartolomé Jocotenango' }, { name: 'San Juan Cotzal', value: 'San Juan Cotzal' }, { name: 'San Pedro Jocopilas', value: 'San Pedro Jocopilas' }, { name: 'Santa Cruz del Quiché', value: 'Santa Cruz del Quiché' }, { name: 'Uspantán', value: 'Uspantán' }, { name: 'Zacualpa', value: 'Zacualpa' },], },
        { name: 'Escuintla', value: 'Escuintla', states: [{ name: 'Escuintla', value: 'Escuintla' }, { name: 'Guanagazapa', value: 'Guanagazapa' }, { name: 'Iztapa', value: 'Iztapa' }, { name: 'La Democracia', value: 'La Democracia' }, { name: 'La Gomera', value: 'La Gomera' }, { name: 'Masagua', value: 'Masagua' }, { name: 'Nueva Concepción', value: 'Nueva Concepción' }, { name: 'Palín', value: 'Palín' }, { name: 'San José', value: 'San José' }, { name: 'San Vicente Pacaya', value: 'San Vicente Pacaya' }, { name: 'Santa Lucía Cotzumalguapa', value: 'Santa Lucía Cotzumalguapa' }, { name: 'Sipacate', value: 'Sipacate' }, { name: 'Siquinalá', value: 'Siquinalá' }, { name: 'Tiquisate', value: 'Tiquisate' },], },
        { name: 'Guatemala', value: 'Guatemala', states: [{ name: 'Amatitlán', value: 'Amatitlán' }, { name: 'Chinautla', value: 'Chinautla' }, { name: 'Chuarrancho', value: 'Chuarrancho' }, { name: 'Fraijanes', value: 'Fraijanes' }, { name: 'Guatemala', value: 'Guatemala' }, { name: 'Mixco', value: 'Mixco' }, { name: 'Palencia', value: 'Palencia' }, { name: 'San Miguel Petapa', value: 'San Miguel Petapa' }, { name: 'San José del Golfo', value: 'San José del Golfo' }, { name: 'San José Pinula', value: 'San José Pinula' }, { name: 'San Juan Sacatepéquez', value: 'San Juan Sacatepéquez' }, { name: 'San Pedro Ayampuc', value: 'San Pedro Ayampuc' }, { name: 'San Pedro Sacatepéquez', value: 'San Pedro Sacatepéquez' }, { name: 'San Raimundo', value: 'San Raimundo' }, { name: 'Santa Catarina Pinula', value: 'Santa Catarina Pinula' }, { name: 'Villa Canales ', value: 'Villa Canales ' }, { name: 'Villa Nueva', value: 'Villa Nueva' }], },
        { name: 'Huehuetenango', value: 'Huehuetenango', states: [{ name: 'Aguacatán', value: 'Aguacatán' }, { name: 'Chiantla', value: 'Chiantla' }, { name: 'Colotenango', value: 'Colotenango' }, { name: 'Concepción Huista', value: 'Concepción Huista' }, { name: 'Cuilco', value: 'Cuilco' }, { name: 'Huehuetenango', value: 'Huehuetenango' }, { name: 'Jacaltenango', value: 'Jacaltenango' }, { name: 'La Democracia', value: 'La Democracia' }, { name: 'La Libertad', value: 'La Libertad' }, { name: 'Malacatancito', value: 'Malacatancito' }, { name: 'Nentón', value: 'Nentón' }, { name: 'Petatán', value: 'Petatán' }, { name: 'San Antonio Huista ', value: 'San Antonio Huista ' }, { name: 'San Gaspar Ixchil ', value: 'San Gaspar Ixchil ' }, { name: 'San Ildefonso Ixtahuacán', value: 'San Ildefonso Ixtahuacán' }, { name: 'San Juan Atitán', value: 'San Juan Atitán' }, { name: 'San Juan Ixcoy', value: 'San Juan Ixcoy' }, { name: 'San Mateo Ixtatán', value: 'San Mateo Ixtatán' }, { name: 'San Miguel Acatán', value: 'San Miguel Acatán' }, { name: 'San Pedro Necta', value: 'San Pedro Necta' }, { name: 'San Pedro Soloma', value: 'San Pedro Soloma' }, { name: 'San Rafael La Independencia', value: 'San Rafael La Independencia' }, { name: 'San Rafael Petzal', value: 'San Rafael Petzal' }, { name: 'San Sebastián Coatán', value: 'San Sebastián Coatán' }, { name: 'San Sebastián Huehuetenango', value: 'San Sebastián Huehuetenango' }, { name: 'Santa Ana Huista', value: 'Santa Ana Huista' }, { name: 'Santa Bárbara', value: 'Santa Bárbara' }, { name: 'Santa Cruz Barillas', value: 'Santa Cruz Barillas' }, { name: 'Santa Eulalia', value: 'Santa Eulalia' }, { name: 'Santiago Chimaltenango ', value: 'Santiago Chimaltenango ' }, { name: 'Tectitán', value: 'Tectitán' }, { name: 'Todos Santos Cuchumatán', value: 'Todos Santos Cuchumatán' }, { name: 'Unión Cantinil', value: 'Unión Cantinil' }] },
        { name: 'Izabal', value: 'Izabal', states: [{ name: 'El Estor', value: 'El Estor' }, { name: 'Livingston', value: 'Livingston' }, { name: 'Los Amates', value: 'Los Amates' }, { name: 'Morales', value: 'Morales' }, { name: 'Puerto Barrios', value: 'Puerto Barrios' },], },
        { name: 'Jalapa', value: 'Jalapa', states: [{ name: 'Jalapa', value: 'Jalapa' }, { name: 'Mataquescuintla', value: 'Mataquescuintla' }, { name: 'Monjas', value: 'Monjas' }, { name: 'San Carlos Alzatate', value: 'San Carlos Alzatate' }, { name: 'San Luis Jilotepeque', value: 'San Luis Jilotepeque' }, { name: 'San Manuel Chaparrón', value: 'San Manuel Chaparrón' }, { name: 'San Pedro Pinula', value: 'San Pedro Pinula' },], },
        { name: 'Jutiapa', value: 'Jutiapa', states: [{ name: 'Agua Blanca', value: 'Agua Blanca' }, { name: 'Asunción Mita', value: 'Asunción Mita' }, { name: 'Atescatempa', value: 'Atescatempa' }, { name: 'Comapa', value: 'Comapa' }, { name: 'Conguaco', value: 'Conguaco' }, { name: 'El Adelanto', value: 'El Adelanto' }, { name: 'El Progreso', value: 'El Progreso' }, { name: 'Jalpatagua', value: 'Jalpatagua' }, { name: 'Jerez', value: 'Jerez' }, { name: 'Jutiapa', value: 'Jutiapa' }, { name: 'Moyuta', value: 'Moyuta' }, { name: 'Pasaco', value: 'Pasaco' }, { name: 'Quesada', value: 'Quesada' }, { name: 'San José Acatempa', value: 'San José Acatempa' }, { name: 'Santa Catarina Mita', value: 'Santa Catarina Mita' }, { name: 'Yupiltepeque', value: 'Yupiltepeque' }, { name: 'Zapotitlán', value: 'Zapotitlán' },], },
        { name: 'Quetzaltenango', value: 'Quetzaltenango', states: [{ name: 'Almolonga', value: 'Almolonga' }, { name: 'Cabricán', value: 'Cabricán' }, { name: 'Cajolá', value: 'Cajolá' }, { name: 'Cantel', value: 'Cantel' }, { name: 'Coatepeque', value: 'Coatepeque' }, { name: 'Colomba', value: 'Colomba' }, { name: 'Concepción Chiquirichapa', value: 'Concepción Chiquirichapa' }, { name: 'El Palmar', value: 'El Palmar' }, { name: 'Flores Costa Cuca', value: 'Flores Costa Cuca' }, { name: 'Génova', value: 'Génova' }, { name: 'Huitán', value: 'Huitán' }, { name: 'La Esperanza', value: 'La Esperanza' }, { name: 'Olintepeque', value: 'Olintepeque' }, { name: 'Palestina de Los Altos', value: 'Palestina de Los Altos' }, { name: 'Quetzaltenango', value: 'Quetzaltenango' }, { name: 'Salcajá', value: 'Salcajá' }, { name: 'San Carlos Sija', value: 'San Carlos Sija' }, { name: 'San Francisco La Unión', value: 'San Francisco La Unión' }, { name: 'San Juan Ostuncalco', value: 'San Juan Ostuncalco' }, { name: 'San Martín Sacatepéquez', value: 'San Martín Sacatepéquez' }, { name: 'San Mateo', value: 'San Mateo' }, { name: 'San Miguel Sigüilá', value: 'San Miguel Sigüilá' }, { name: 'Sibilia', value: 'Sibilia' }, { name: 'Zunil', value: 'Zunil' },], },
        { name: 'Retalhuleu', value: 'Retalhuleu', states: [{ name: 'Champerico', value: 'Champerico' }, { name: 'El Asintal', value: 'El Asintal' }, { name: 'Nuevo San Carlos', value: 'Nuevo San Carlos' }, { name: 'Retalhuleu', value: 'Retalhuleu' }, { name: 'San Andrés Villa Seca', value: 'San Andrés Villa Seca' }, { name: 'San Felipe', value: 'San Felipe' }, { name: 'San Martín Zapotitlán', value: 'San Martín Zapotitlán' }, { name: 'San Sebastián', value: 'San Sebastián' }, { name: 'Santa Cruz Muluá', value: 'Santa Cruz Muluá' },], },
        { name: 'Sacatepéquez', value: 'Sacatepéquez', states: [{ name: 'Alotenango', value: 'Alotenango' }, { name: 'Antigua Guatemala', value: 'Antigua Guatemala' }, { name: 'Ciudad Vieja', value: 'Ciudad Vieja' }, { name: 'Jocotenango', value: 'Jocotenango' }, { name: 'Magdalena Milpas Altas', value: 'Magdalena Milpas Altas' }, { name: 'Pastores', value: 'Pastores' }, { name: 'San Antonio Aguas Calientes', value: 'San Antonio Aguas Calientes' }, { name: 'San Bartolomé Milpas Altas', value: 'San Bartolomé Milpas Altas' }, { name: 'San Lucas Sacatepéquez ', value: 'San Lucas Sacatepéquez ' }, { name: 'San Miguel Dueñas', value: 'San Miguel Dueñas' }, { name: 'Santiago Sacatepéquez', value: 'Santiago Sacatepéquez' }, { name: 'Santa Catarina Barahona', value: 'Santa Catarina Barahona' }, { name: 'Santa Lucía Milpas Altas', value: 'Santa Lucía Milpas Altas' }, { name: 'Santa María de Jesús', value: 'Santa María de Jesús' }, { name: 'Santo Domingo Xenacoj', value: 'Santo Domingo Xenacoj' }, { name: 'Sumpango', value: 'Sumpango' },], },
        { name: 'San Marcos', value: 'San Marcos', states: [{ name: 'Ayutla', value: 'Ayutla' }, { name: 'Catarina', value: 'Catarina' }, { name: 'Comitancillo', value: 'Comitancillo' }, { name: 'Concepción Tutuapa', value: 'Concepción Tutuapa' }, { name: 'El Quetzal', value: 'El Quetzal' }, { name: 'El Rodeo', value: 'El Rodeo' }, { name: 'El Tumbador', value: 'El Tumbador' }, { name: 'Esquipulas Palo Gordo', value: 'Esquipulas Palo Gordo' }, { name: 'Ixchiguan ', value: 'Ixchiguan ' }, { name: 'La Blanca', value: 'La Blanca' }, { name: 'La Reforma', value: 'La Reforma' }, { name: 'Malacatán', value: 'Malacatán' }, { name: 'Nuevo Progreso', value: 'Nuevo Progreso' }, { name: 'Ocos', value: 'Ocos' }, { name: 'Pajapita', value: 'Pajapita' }, { name: 'Río Blanco', value: 'Río Blanco' }, { name: 'San Antonio Sacatepéquez', value: 'San Antonio Sacatepéquez' }, { name: 'San Cristóbal Cucho', value: 'San Cristóbal Cucho' }, { name: 'San José Ojetenam', value: 'San José Ojetenam' }, { name: 'San Lorenzo', value: 'San Lorenzo' }, { name: 'San Marcos', value: 'San Marcos' }, { name: 'San Miguel Ixtahuacán', value: 'San Miguel Ixtahuacán' }, { name: 'San Pablo', value: 'San Pablo' }, { name: 'San Pedro Sacatepéquez', value: 'San Pedro Sacatepéquez' }, { name: 'San Rafael Pie de la Cuesta', value: 'San Rafael Pie de la Cuesta' }, { name: 'Sibinal', value: 'Sibinal' }, { name: 'Sipacapa', value: 'Sipacapa' }, { name: 'Tacaná', value: 'Tacaná' }, { name: 'Tajumulco', value: 'Tajumulco' }, { name: 'Tejutla', value: 'Tejutla' },], },
        { name: 'Santa Rosa', value: 'Santa Rosa', states: [{ name: 'Barberena', value: 'Barberena' }, { name: 'Casillas', value: 'Casillas' }, { name: 'Chiquimulilla', value: 'Chiquimulilla' }, { name: 'Cuilapa', value: 'Cuilapa' }, { name: 'Guazacapán', value: 'Guazacapán' }, { name: 'Nueva Santa Rosa', value: 'Nueva Santa Rosa' }, { name: 'Oratorio', value: 'Oratorio' }, { name: 'Pueblo Nuevo Viñas', value: 'Pueblo Nuevo Viñas' }, { name: 'San Juan Tecuaco', value: 'San Juan Tecuaco' }, { name: 'San Rafael Las Flores', value: 'San Rafael Las Flores' }, { name: 'Santa Cruz Naranjo', value: 'Santa Cruz Naranjo' }, { name: 'Santa María Ixhuatán', value: 'Santa María Ixhuatán' }, { name: 'Santa Rosa de Lima', value: 'Santa Rosa de Lima' }, { name: 'Taxisco ', value: 'Taxisco ' }, { name: '', value: '' },], },
        { name: 'Sololá', value: 'Sololá', states: [{ name: 'Concepción', value: 'Concepción' }, { name: 'Nahualá', value: 'Nahualá' }, { name: 'Panajachel', value: 'Panajachel' }, { name: 'San Andrés Semetabaj', value: 'San Andrés Semetabaj' }, { name: 'San Antonio Palopó', value: 'San Antonio Palopó' }, { name: 'San José Chacayá', value: 'San José Chacayá' }, { name: 'San Juan La Laguna', value: 'San Juan La Laguna' }, { name: 'San Lucas Tolimán', value: 'San Lucas Tolimán' }, { name: 'San Marcos La Laguna', value: 'San Marcos La Laguna' }, { name: 'San Pablo La Laguna ', value: 'San Pablo La Laguna ' }, { name: 'San Pedro La Laguna', value: 'San Pedro La Laguna' }, { name: 'Santa Catarina Ixtahuacan', value: 'Santa Catarina Ixtahuacan' }, { name: 'Santa Catarina Palopó', value: 'Santa Catarina Palopó' }, { name: 'Santa Clara La Laguna', value: 'Santa Clara La Laguna' }, { name: 'Santa Cruz La Laguna', value: 'Santa Cruz La Laguna' }, { name: 'Santa Lucía Utatlán', value: 'Santa Lucía Utatlán' }, { name: 'Santa María Visitación', value: 'Santa María Visitación' }, { name: 'Santiago Atitlán', value: 'Santiago Atitlán' }, { name: 'Sololá', value: 'Sololá' },], },
        { name: 'Suchitepéquez', value: 'Suchitepéquez', states: [{ name: 'Chicacao', value: 'Chicacao' }, { name: 'Cuyotenango', value: 'Cuyotenango' }, { name: 'Mazatenango', value: 'Mazatenango' }, { name: 'Patulul', value: 'Patulul' }, { name: 'Pueblo Nuevo', value: 'Pueblo Nuevo' }, { name: 'Río Bravo', value: 'Río Bravo' }, { name: 'Samayac', value: 'Samayac' }, { name: 'San Antonio Suchitepéquez', value: 'San Antonio Suchitepéquez' }, { name: 'San Bernardino', value: 'San Bernardino' }, { name: 'San Francisco Zapotitlán', value: 'San Francisco Zapotitlán' }, { name: 'San Gabriel', value: 'San Gabriel' }, { name: 'San José El Idolo', value: 'San José El Idolo' }, { name: 'San José La Máquina', value: 'San José La Máquina' }, { name: 'San Juan Bautista', value: 'San Juan Bautista' }, { name: 'San Lorenzo', value: 'San Lorenzo' }, { name: 'San Miguel Panán', value: 'San Miguel Panán' }, { name: 'San Pablo Jocopilas', value: 'San Pablo Jocopilas' }, { name: 'Santa Bárbara', value: 'Santa Bárbara' }, { name: 'Santo Domingo Suchitepéquez', value: 'Santo Domingo Suchitepéquez' }, { name: 'Santo Tomás La Unión', value: 'Santo Tomás La Unión' }, { name: 'Zunilito', value: 'Zunilito' },], },
        { name: 'Totonicapán', value: 'Totonicapán', states: [{ name: 'Momostenango', value: 'Momostenango' }, { name: 'San Andrés Xecul', value: 'San Andrés Xecul' }, { name: 'San Bartolo', value: 'San Bartolo' }, { name: 'San Cristóbal Totonicapán', value: 'San Cristóbal Totonicapán' }, { name: 'San Francisco El Alto', value: 'San Francisco El Alto' }, { name: 'Santa Lucía La Reforma', value: 'Santa Lucía La Reforma' }, { name: 'Santa María Chiquimula', value: 'Santa María Chiquimula' }, { name: 'Totonicapán', value: 'Totonicapán' },], },
        { name: 'Zacapa', value: 'Zacapa', states: [{ name: 'Cabañas', value: 'Cabañas' }, { name: 'Estanzuela', value: 'Estanzuela' }, { name: 'Gualán', value: 'Gualán' }, { name: 'Huité', value: 'Huité' }, { name: 'La Unión', value: 'La Unión' }, { name: 'Río Hondo', value: 'Río Hondo' }, { name: 'San Diego', value: 'San Diego' }, { name: 'San Jorge', value: 'San Jorge' }, { name: 'Teculután', value: 'Teculután' }, { name: 'Usumatlán', value: 'Usumatlán' }, { name: 'Zacapa', value: 'Zacapa' },], },
    ];
    const archivos = [{ value: '1', name: '1 - Guatemala' }, { value: '2', name: '2 - El Progreso' }, { value: '3', name: '3 - Sacatepéquez' }, { value: '4', name: '4 - Chimaltenango' }, { value: '5', name: '5 - Escuintla' }, { value: '6', name: '6 - Santa Rosa' }, { value: '7', name: '7 - Sololá' }, { value: '8', name: '8 - Totonicapán' }, { value: '9', name: '9 - Quetzaltenango' }, { value: '10', name: '10 - Suchitepequez' }, { value: '11', name: '11 - Retalhuleu' }, { value: '12', name: '12 - San Marcos' }, { value: '13', name: '13 - Huehuetenango' }, { value: '14', name: '14 - El Quiché' }, { value: '15', name: '15 - Baja Verapaz' }, { value: '16', name: '16 - Alta Verapaz' }, { value: '17', name: '17 - El Peten' }, { value: '18', name: '18 - Izabal' }, { value: '19', name: '19 - Zacapa' }, { value: '20', name: '20 - Chiquimula' }, { value: '21', name: '21 - Jalapa' }, { value: '22', name: '22 - Jutiapa' }, { value: '23', name: '23 - Jalapa-Jutiapa' }, { value: '90', name: '90 - Propiedad Horizontal Guatemala' }, { value: '91', name: '91 - Grupo Norte' }, { value: '92', name: '92 - Propiedad Horizontal Escuintla' }, { value: '93', name: '93 - Propiedad Horizontal Sacatepéquez' }, { value: '94', name: '94 - Libro Antiguo' }, { value: '95', name: '95 - Propiedad Horizontal Alta Verapaz' }, { value: '96', name: '96 - Vivienda Popular' }, { value: '97', name: '97 - Propiedad Horizontal de Quetzaltenango' }, { value: '98', name: '98 - Transformación Agraria' }, { value: '99', name: '99 - Reforma Agraria' }, { value: '100', name: '100 - Inscripciones Especiales' }, { value: '101', name: '101 - Concesiones' }, { value: '102', name: '102 - Minas' }, { value: '103', name: '103 - Bienes Muebles de Quetzaltenango' }, { value: '104', name: '104 - Libro de Aguas de Quetzaltenango' }, { value: '105', name: '105 - Prenda Especial' }, { value: '106', name: '106 - Prenda Agraria' }, { value: '107', name: '107 - Prenda Ganadera' }, { value: '108', name: '108 - Prenda Industrial' }, { value: '109', name: '109 - Prenda Agricola Industrial' }, { value: '110', name: '110 - Libro de Minas de Quetzaltenango' }, { value: '111', name: '111 - Libro Bienes de la Nacion' }, { value: '112', name: '112 - Prenda Agraria de Quetzaltenango' }, { value: '113', name: '113 - Concesiones Quetzaltenango' }, { value: '117', name: '117 - Primera Serie' }, { value: '120', name: '120 - Amatitlan' }, { value: '125', name: '125 - Vehículos Motorizados' }, { value: '126', name: '126 - Prendas de Vehículos Motorizados' }, { value: '127', name: '127 - Ferrocarriles' }, { value: '128', name: '128 - Diario de Alta Verapaz' }, { value: '129', name: '129 - Naves y Aeronaves' }, { value: '130', name: '130 - Testamentos' }, { value: '131', name: '131 - Testamentos Quetzaltenango' }, { value: '132', name: '132 - Vehículos Motorizados Quetzaltenango' }, { value: '133', name: '133 - Prendas de Vehículos Motorizados Quetzaltenango' }, { value: '134', name: '134 - Propiedad Horizontal de Solola' }, { value: '135', name: '135 - Propiedad Horizontal de Totonicapan' }, { value: '136', name: '136 - Propiedad Horizontal de Suchitepequez' }, { value: '137', name: '137 - Propiedad Horizontal de Retalhuleu' }, { value: '138', name: '138 - Propiedad Horizontal de San Marcos' }, { value: '139', name: '139 - Propiedad Horizontal de Huehuetenango' }, { value: '140', name: '140 - Propiedad Horizontal de El Quiche' }, { value: '141', name: '141 - Propiedad Horizontal Izabal' }, { value: '142', name: '142 - Inscripciones Especiales Quetzaltenango' }, { value: '143', name: '143 - Propiedad Horizontal de Santa Rosa' }, { value: '144', name: '144 - Propiedad Horizontal de El Peten' }, { value: '145', name: '145 - Prenda Especial Quetzaltenango' }, { value: '146', name: '146 - Prenda Agraria Bandesa' }, { value: '147', name: '147 - Prenda Especial Bandesa' }, { value: '148', name: '148 - Prenda Ganadera Bandesa' }, { value: '149', name: '149 - Prenda Pequena Empresa' }, { value: '150', name: '150 - Propiedad Horizontal Jutiapa' }, { value: '151', name: '151 - Libro de Minas de El Quiché' }, { value: '152', name: '152 - Libro de Minas e Hidrocarburos de Solola' }, { value: '153', name: '153 - Propiedad Horizontal Chimaltenango' }, { value: '154', name: '154 - Diario de Grupo Norte' },];
    const [municipios, setMunicipios] = React.useState([{ name: 'Chahal', value: 'Chahal' }, { name: 'Chisec', value: 'Chisec' }, { name: 'Cobán', value: 'Cobán' }, { name: 'Fray Bartolomé de las Casas', value: 'Fray Bartolomé de las Casas' }, { name: 'San Agustín Lanquín', value: 'San Agustín Lanquín' }, { name: 'Panzós', value: 'Panzós' }, { name: 'Raxruha', value: 'Raxruha' }, { name: 'San Cristóbal Verapaz', value: 'San Cristóbal Verapaz' }, { name: 'San Juan Chamelco', value: 'San Juan Chamelco' }, { name: 'San Pedro Carchá', value: 'San Pedro Carchá' }, { name: 'Santa Cruz Verapaz', value: 'Santa Cruz Verapaz' }, { name: 'Santa María Cahabón', value: 'Santa María Cahabón' }, { name: 'Senahú', value: 'Senahú' }, { name: 'Tactic', value: 'Tactic' }, { name: 'Tamahú', value: 'Tamahú' }, { name: 'Tucurú', value: 'Tucurú' }, { name: 'Santa Catalina la Tinta', value: 'Santa Catalina la Tinta' }]);

    /* const setValue = (depto) => {
        setMunicipios(depto.states);

        dispatch(third({
            ...data,
            departamento: depto.value
        }));
    }; */

    return (
        <>

            <Grid container wrap="nowrap" spacing={2}>
                <form className={classes.root} autoComplete="off">
                    <TextField
                        id="outlined-full-width"
                        label="Direccion"
                        style={{ marginRight: 8, marginTop: 8, marginBottom: 8 }}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        size="small"
                        /* required */
                        inputProps={{ style: { fontSize: '0.8rem' } }}
                        InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                        error={error.direccion}
                        name="direccion"
                        value={direccion}
                        onChange={onChangeFormulario}

                    />
                    <TextField
                        id="outlined-full-width"
                        label="Zona"
                        style={{ marginRight: 8, marginTop: 8, marginBottom: 8 }}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        size="small"
                        /* required */
                        inputProps={{ style: { fontSize: '0.8rem' } }}
                        InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                        error={error.zona}
                        name="zona"
                        value={zona}
                        onChange={onChangeFormulario}

                    />

                    <Autocomplete
                        id="combo-box-demo"
                        size={"small"}
                        name="departamento"
                        value={{ name: departamento == '' ? 'Seleccione uno...' : departamento, value: departamento == '' ? 'Seleccione uno...' : departamento }}
                        options={countries}
                        getOptionLabel={(option) => option.name}
                        style={{ marginRight: 8, marginTop: 8, marginBottom: 8 }}
                        autoHighlight


                        onChange={(event, value) => onChangeFormularioCombo(event, value, "departamento")}
                        /* required */
                        fullWidth
                        className={classes.auto}
                        classes={{
                            option: classes.option,
                        }}
                        disableClearable


                        renderInput={(params) => <TextField {...params} className={classes.auto} label="Departamento" value={departamento} error={error.departamento} variant="outlined" inputProps={{ ...params.inputProps, style: { fontSize: "0.8rem" } }} InputLabelProps={{ ...params.InputLabelProps, style: { fontSize: "0.8rem" } }} />}
                    />
                    <Autocomplete
                        id="combo-box-demo"
                        size={"small"}
                        value={{ name: municipio, value: municipio }}
                        options={municipios}
                        getOptionLabel={(option) => option.name}
                        style={{ marginRight: 8, marginTop: 16, marginBottom: 8 }}
                        autoHighlight

                        onChange={(event, value) => onChangeFormularioCombo(event, value, "municipio")}
                        /* required */
                        fullWidth
                        className={classes.auto}
                        classes={{
                            option: classes.option,
                        }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} className={classes.auto} label="Municipio" error={error.municipio} variant="outlined" inputProps={{ ...params.inputProps, style: { fontSize: "0.8rem" } }} InputLabelProps={{ ...params.InputLabelProps, style: { fontSize: "0.8rem" } }} />}
                    />

                    <Box
                        component="span"
                        m={1}
                        className={`${classes.spreadBox} ${classes.box}`}
                    >
                        <FormHelperText >Datos del Registro de la propiedad</FormHelperText>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.buttonCustom}
                            startIcon={<HelpIcon />}
                            size="small"
                            onClick={handleClickOpen}

                        >
                            Necesito ayuda
                        </Button>
                    </Box>
                    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                            Te ayudamos
                        </DialogTitle>
                        <DialogContent dividers>
                            <Typography gutterBottom>
                                No te preocupes, un asesor se
                                pondrá en contacto contigo para
                                ayudarte a conseguir estos datos.
                                O cualquier duda también puedes
                                escribirnos por Whatsapp:
                            </Typography>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    startIcon={<WhatsAppIcon />}
                                    size="large"
                                    style={{ margin: 8 }}
                                >
                                    <a style={{ color: 'inherit ', textDecoration: 'none' }} href='https://wa.me/50232474460' target='_blank'>
                                        Haz click Aqui
                                    </a>
                                </Button>
                            </Box>



                        </DialogContent>
                        <DialogActions>
                            <Button autoFocus onClick={handleClose} color="primary">
                                Volver al formulario
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <TextField
                        id="outlined-full-width"
                        label="Finca"
                        style={{ marginRight: 8, marginTop: 8, marginBottom: 8 }}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        size="small"
                        inputProps={{ style: { fontSize: '0.8rem' } }}
                        InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                        name="finca"
                        value={finca}
                        onChange={onChangeFormulario}

                    />

                    <TextField
                        id="outlined-full-width"
                        label="Folio"
                        style={{ marginRight: 8, marginTop: 8, marginBottom: 8 }}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        size="small"
                        inputProps={{ style: { fontSize: '0.8rem' } }}
                        InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                        name="folio"
                        value={folio}
                        onChange={onChangeFormulario}

                    />
                    <TextField
                        id="outlined-full-width"
                        label="Libro"
                        style={{ marginRight: 8, marginTop: 8 }}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        size="small"
                        inputProps={{ style: { fontSize: '0.8rem' } }}
                        InputLabelProps={{ style: { fontSize: '0.8rem' } }}
                        name="libro"
                        value={libro}
                        onChange={onChangeFormulario}

                    />
                    <Autocomplete
                        id="combo-box-demo"
                        size={"small"}
                        value={{ name: archivo, value: archivo }}
                        options={archivos}
                        getOptionLabel={(option) => option.name}
                        style={{ marginTop: 8, marginBottom: 16 }}
                        autoHighlight
                        fullWidth
                        className={classes.auto}
                        classes={{
                            option: classes.option,
                        }}
                        onChange={(event, value) => onChangeFormularioCombo(event, value, "archivo")}
                        disableClearable
                        renderInput={(params) => <TextField {...params} className={classes.auto} label="Archivo" variant="outlined" inputProps={{ ...params.inputProps, style: { fontSize: "0.8rem" } }} InputLabelProps={{ ...params.InputLabelProps, style: { fontSize: "0.8rem" } }} />}
                    />

                    {/* <FormHelperText style={{ marginRight: 8, marginTop: 4, marginBottom: 4 }}>(*) Obligatorio</FormHelperText> */}
                </form>
            </Grid>
        </>
    );

}





export default FormScreen3;